<template>
  <div>
    <div class="page f-pr">
      <img src="../assets/images/bg_01.jpg" alt="">
      <div class="f-pr">
        <div class="img-row">
          <img src="../assets/images/bg_02.jpg" alt="">
        </div>
        <div class="shop-img">
          <img :src="'https://science.warnny.com/fulong/store/' + storeId + '.png'" alt="" srcset="" />
        </div>
      </div>

      <div class="page1-content">

        <div class="fcc">
          <div class="fcc f-pr btn-like" @click.stop="showSignPopup()">
            <img src="../assets/title-dpjj.png" alt="" srcset="" class="title-img" />
            <img src="../assets/btn-msgz.png" alt="" srcset="" class="msgz gif" />
          </div>
        </div>

        <div style="height:50px;"></div>

        <div class="fcc">
          <img src="../assets/title-hzsj.png" alt="" srcset="" class="title-img" />
        </div>
        <div class="article">
          <h3>
            {{ storeInfo.nameCh }}
          </h3>
          <p>
            {{ storeInfo.nameEn }}
          </p>
        </div>
        <div class="fcc">
          <img src="../assets/title-dz.png" alt="" srcset="" class="title-img" />
        </div>
        <div class="article">

          <p>
            <!-- {{ storeInfo.addressCh }} <br>G/F, 4 Travessa da Felicidade. <br>Avenida de Almeida Ribeiro -->
            {{ storeInfo.addressCh }} <br>{{ storeInfo.addressEn }}
          </p>
        </div>
        <div class="fcc">
          <img src="../assets/title-yysj.png" alt="" srcset="" class="title-img" />
        </div>
        <div class="article">
          <h3>
            {{ storeInfo.openTime }}
          </h3>

        </div>
        <div class="fcc">
          <img src="../assets/title-dpjj.png" alt="" srcset="" class="title-img" />
        </div>
        <div class="article">
          <p>
            {{ storeInfo.introductionCh }}
          </p>
          <p>
            {{ storeInfo.introductionEn }}
          </p>
        </div>

        <div class="fcc" v-if="storeInfo.remarkCh || storeInfo.remarkEn">
          <img src="../assets/title-shhh.png" alt="" srcset="" class="title-img" />
        </div>
        <div class="article" v-if="storeInfo.remarkCh || storeInfo.remarkEn">
          <h3 style="color:#C95238;">
            {{ storeInfo.remarkCh }}
          </h3>
          <h3 style="color:#C95238;">
            {{ storeInfo.remarkEn }}
          </h3>
        </div>

        <!-- <div class="fcc">
          <div class="fcc f-pr btn-like" @click.stop="showSignPopup()">
            <img src="../assets/title-dpjj.png" alt="" srcset="" class="title-img" />
            <img src="../assets/btn-msgz.png" alt="" srcset="" class="msgz gif" />
          </div>
        </div> -->
        <div style="height:60px;"></div>
      </div>








    </div>
    <van-overlay :show="showPopSign" z-index="999" @touchstart="handleTouchStart">
      <div class="fcc-h gz-pop gz-pop-bgimg" style="height: 100vh; overflow: auto">
        <div class="f-pr gz-pop-con fc-h" @click.stop="">


          <input type="text" v-model="inputMoney" @input="handleInput" class="input-money"
            placeholder="請輸入 Please enter">
          <!-- 盖章区域 -->
          <div class="gz-area fcc f-pr">

          </div>

          <div class="x-btn fcc" @click.stop="showPopSign = !showPopSign">
            <img src="../assets/x.png" alt="" srcset="" />
          </div>
        </div>
      </div>
    </van-overlay>


    <van-overlay :show="showSign" z-index="999" :lock-scroll="false" @touchstart="handleTouchStart">
      <div class=" gz-pop fcc-h" style="height: 100vh; overflow: auto">
        <!-- 活动规则 -->
        <div class="f-pr gb-dk">
          <img src="../assets/bar/gb-dk.png" alt="" srcset="" class="gb-dk" />

          <div class="x-btn fcc" @click.stop="showSign = !showSign">
            <img src="../assets/x.png" alt="" srcset="" />
          </div>
        </div>


      </div>
    </van-overlay>


    <van-overlay :show="showLoading">
      <div class="fcc-h " style="height: 100vh;">
        <van-loading size="24px" vertical color="#fff">Loading...</van-loading>
      </div>
    </van-overlay>

    <div style="
        position: fixed;
        left: 110%;
        top: 110%;
        width: 0;
        height: 0;
        overflow: hidden;
      ">
      <audio id="audioID" ref="audio" class="aud">
        <source src="https://science.warnny.com/fulong/duang.mp3" type="audio/mp3" />
      </audio>
    </div>
  </div>
</template>

<script>
import { getStoreInfo, checkTask, login } from '@/api/api'
import CryptoJS from 'crypto-js'

export default {
  data() {
    return {
      showLoading: false,
      showPopSign: false,
      showSign: false,
      storeInfo: {},
      storeId: '',
      inputMoney: '',
      type: '地图打卡',
      uid: '',
      userInfo: {},
      checking: false,
    }
  },
  async mounted() {
    // this.uid = window.localStorage.getItem('openId')
    // if (this.uid && this.uid != 'null' && this.uid != 'undefinded') {
    //   this.login(this.uid)
    // } else {
    //   this.$router.push({ path: '/' })
    //   return
    // }
    this.storeId = 1
    this.type = window.localStorage.getItem('clockType')
    // if (!this.storeId || !this.type) {
    //   this.$router.push({ path: '/' })
    //   return
    // }
    window.localStorage.removeItem('storeId')
    window.localStorage.removeItem('clockType')
    this.getStoreInfo()

    this.$nextTick(() => {
      let Media = document.getElementById("audioID");
      Media.src = "http://science.warnny.com/fulong/duang.mp3";
    });
  },
  methods: {
    login(uid) {
      let self = this
      self.showLoading = true
      login({
        username: uid
      }).then(res => {
        if (res.status != 200) {
          this.$toast(res.msg)
          return
        } else {
          window.localStorage.setItem('uid', res.data.userInfo.username)
          self.uid = res.data.userInfo.username
          self.userInfo = res.data.userInfo
          self.showLoading = false
        }
      })
    },
    async getStoreInfo() {
      this.showLoading = true
      let res = await getStoreInfo(this.storeId)
      this.storeInfo = res.data
      console.log(this.storeInfo)
      this.showLoading = false
    },
    handleInput(e) {
      // 校驗是否為數字包含小數點
      const reg = /^-?(\d+(\.\d*)?|\.\d+)$/;
      if (!reg.test(e.target.value)) {
        this.$toast('請輸入數字\nPlease enter the number')
        this.inputMoney = ''
        return
      }
      this.inputMoney = e.target.value

    },
    async handleTouchStart(event) {

      let that = this;
      if (event.touches.length != 4) {
        return
      }
      if (this.type == 'map') {
        if (!this.inputMoney || this.inputMoney == 0) {
          this.$toast('請輸入消費金額\nPlease enter the purchase\n amount Confirm')
          return
        }
        if (this.inputMoney < 30) {
          this.inputMoney = ''
          this.$toast('消費金額不能低於30\nThe purchase amount \ncannot be less than 30')
          return
        }
      }

      let timestamp = new Date().getTime();
      // 获取触摸点的坐标
      let touchArr = []
      for (let i = 0; i < event.touches.length; i++) {
        var touchX = event.touches[i].clientX;
        var touchY = event.touches[i].clientY;
        let touchItem = [touchX, touchY]
        touchArr.push(touchItem)
      }
      if (this.checking) {
        return
      }
      this.checking = true
      //时间戳
      let request = {
        storeId: that.storeId,
        array: touchArr,
        timestamp: timestamp,
        userId: this.uid,
        type: this.type, // 1打卡；2抽奖；3纪念品
        amount: this.inputMoney || 0
      }
      let md5Result = CryptoJS.MD5(request.storeId.toString() + request.timestamp.toString() + request.userId.toString()).toString();
      request.sign = md5Result
      request.method = 1
      checkTask(request).then(res => {
        if (res && res.msg) {
          this.$toast(res.msg)
          this.checking = false
        } else if (res) {
          that.showPopSign = false
          that.showSign = false
          that.$toast("打卡成功")
          document.querySelector('audio').play()
          document.getElementById("audioID").play()
          this.checking = false
        } else {
          if (res.msg) {
            that.$toast("打卡失败，请重试")
            this.checking = false
          }
        }
      })
    },
    showSignPopup() {
      // this.$toast('活動已經結束\n活動日期為2025年10月1日至8日\nThe event has already ended.\nThe event date was from \nOctober 1 to October 8, 2025.')
      // return
      this.inputMoney = ''
      if (this.type == 'map') {
        this.showPopSign = true
      } else {
        this.showSign = true
      }
    }
  }


}
</script>
<style scoped lang="less">
.page {
  display: block;

  min-height: 100vh;
  background: #fff url(../assets/bg-y.jpg) center 0 repeat-y;
  background-size: 100% auto;
  position: relative;

  >img {
    display: block;
    width: 100%;
  }
}

.page1-content {
  background: url(../assets/images/bg_03.jpg) no-repeat;
  background-size: 100% auto;
  min-height: 50vh;
  padding-top: 20px;
}

.title-img {
  width: 248px;
  display: block;
}

.article {
  width: 55vw;
  margin: 0 auto;
  text-align: center;
  padding: 15px 0;
  font-size: 24px;
  line-height: 44px;

  h3 {
    font-size: 24px;
    margin: 0;
  }

  p {
    margin: 0;
    line-height: 36px;
  }

  p+p {
    margin-top: 1em;
  }
}

.btn-go {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 15%;

  img {
    width: 291px;
    height: 72px;
    object-fit: contain;
  }
}

.btn-like {
  img {
    opacity: 0;
  }

  .msgz {
    position: absolute;
    width: 323px;
    left: 0;
    top: 0;
    opacity: 1;
  }
}

.x-btn {
  width: 127px;
  height: 127px;
  position: absolute;
  left: -25px;
  top: -38px;

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.input-money {
  width: 375px;

  border: 1px solid #00A082;
  text-align: center;
  line-height: 54px;
  background: #fff;
  font-size: 34px;
  padding-top: 4px;
  padding-bottom: 4px;
  margin-bottom: 30px;
}

.gz-pop-con {
  width: 630px;
  height: 775px;
  background: url(../assets/gz-pop-img.png) center no-repeat;
  background-size: contain;
  padding-top: 185px;
  box-sizing: border-box;
}

.gif {
  -webkit-animation: gif 1s infinite linear;
  animation: gif 1s infinite linear;
}

.gz-area {
  width: 100%;
  padding-bottom: 70%;
  // background: red;
  opacity: .5;
}

@keyframes gif {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

@-webkit-keyframes gif {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.gb-dk {
  width: 595px;
  margin: 0 auto;
  position: relative;

  .x-btn {
    top: -60px;
  }
}

.shop-img {
  width: 380px;
  height: 380px;
  position: absolute;
  left: 185px;
  top: 10px;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>